import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Parametri } from '../../../modals/Parametri.model';
import { Ad } from '../../../modals/ad.model';
 
@Injectable({
  providedIn: 'root'
})
export class AdsService {
  private apiUrl = 'https://weberp-api.com/api/main/GetDataSet?NazivProc=proc_dbReklama';

  constructor(private http: HttpClient) {}

  getAdsData(): Observable<Ad[]> {
    return this.http.post<Ad[]>(this.apiUrl,[
      { Tip: 'string', Naziv: 'akcija', Izraz: 'default' },
      { Tip: 'int', Naziv: 'IDKlijenta', Broj: 1095 },
      { Tip: 'int', Naziv: 'IDJezika', Broj: 1 }
    ])
  }
}
